import SimulationIndex from '@views/sims/index';
import SimulationShow from '@views/sims/show';
import SimulationSectionShow from '@views/sims/sections/show';
import SimulationFlashcard from '@views/sims/flashcards/show';
import SimulationSectionReview from '@views/sims/sections/review';
import SimulationSectionBreak from '@views/sims/sections/break';
import SimulationPerformance from '@views/sims/performance';

// The following routes are for single section simulations only (i.e. Nursing)
import SimulationIntro from '@views/sims/intro';
import SimulationOutro from '@views/sims/outro';
import SimulationFlashcardAllTypes from '@views/sims/flashcards/showAllTypes';
import ProgressFlashcardComponent from '@views/progress/questions/show';
import SimulationReview from '@views/sims/review';

export default [
  {
    path: '/sims',
    name: 'sims#index',
    component: SimulationIndex,
  },
  {
    path: '/sims/:simId?',
    name: 'sims#show',
    component: SimulationShow,
  },
  {
    path: '/sims/:simId/sections/:sectionId',
    name: 'simSection#show',
    component: SimulationSectionShow,
  },
  {
    path: '/sims/:simId/sections/:sectionId/flashcards/:flashcardId',
    name: 'simSectionFlashcard#show',
    component: SimulationFlashcard,
  },
  {
    path: '/sims/:simId/sections/:sectionId/review',
    name: 'simSection#review',
    component: SimulationSectionReview,
  },
  {
    path: '/sims/:simId/review',
    name: 'sims#review',
    component: SimulationReview,
  },
  {
    path: '/sims/:simId/sections/:sectionId/break',
    name: 'simSection#break',
    component: SimulationSectionBreak,
  },
  {
    path: '/sims/:simId/performance',
    name: 'sims#performance',
    component: SimulationPerformance,
  },
  {
    path: '/sims/:simId/intro/:pageNum',
    name: 'sims#intro',
    component: SimulationIntro,
  },
  {
    path: '/sims/:simId/outro',
    name: 'sims#outro',
    component: SimulationOutro,
  },
  {
    path: '/sims/:simId/flashcards/:flashcardId',
    name: 'simFlashcard#show',
    component: SimulationFlashcardAllTypes,
  },
  {
    path: '/sims/:categoryId/results/:blueprintId/',
    name: 'sims#results',
    component: () => import(/* webpackChunkName: "quizzes/results" */ '@views/quizzes/results'),
    meta: {
      header: true,
      simulation: true,
    },
  },
  {
    path: '/sims/:categoryId/results/:blueprintId/:flashcardId',
    component: ProgressFlashcardComponent,
    name: 'sims#results#question',
    meta: {
      header: true,
      masteryFooter: true,
      simulation: true,
    },
  },
];
